// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__pEZ9F","ranges":"BmiRanges_ranges__19vkz"};